<template>
  <div v-if="isEditMode">
    <v-dialog
      max-width="300px"
      ref="dateDialog"
      v-model="dateDialog"
      eager
      :return-value.sync="dueDate"
      @keydown.esc="dateDialog = false"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          dense
          readonly
          outlined
          clearable
          class="mb-6"
          prepend-inner-icon="mdi-calendar"
          :hide-details="!isDateMissing"
          :label="$t('common.due_date')"
          :error-messages="
            isDateMissing ? $t('rev.due_date_missing_error') : null
          "
          :value="formattedDate"
          @click:clear="clearDueDate"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        ref="dateDialogPicker"
        v-model="dueDate"
        @input="$refs.dateDialog.save(dueDate)"
        @change="onDueDateChange"
      />
    </v-dialog>

    <v-dialog
      width="470px"
      ref="timeDialog"
      v-model="timeDialog"
      eager
      :return-value.sync="dueTime"
      @keydown.esc="timeDialog = false"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          dense
          readonly
          outlined
          hide-details
          class="mb-6"
          prepend-inner-icon="mdi-timer-outline"
          :label="$t('rev.expiration_time')"
          :value="dueTime"
        ></v-text-field>
      </template>
      <v-time-picker
        landscape
        format="ampm"
        ref="timeDialogPicker"
        v-model="dueTime"
        @click:minute="$refs.timeDialog.save(dueTime)"
        @change="onDueTimeChange"
      >
      </v-time-picker>
    </v-dialog>
  </div>
  <div v-else>
    <div v-if="!isEditMode && formattedDate">
      <label class="label grey--text text--darken-2 d-block mb-2">
        {{ $t('common.due_date') }}
      </label>
      <v-chip outlined small class="mb-4">
        <v-icon small left color="grey">
          mdi-calendar-outline
        </v-icon>
        {{ formattedDate }}
      </v-chip>
      <label class="label grey--text text--darken-2 d-block mb-2">
        {{ $t('rev.expiration_time') }}
      </label>
      <v-chip outlined small class="mb-4">
        <v-icon small left color="grey">mdi-timer-outline</v-icon>
        {{ dueTime }}
      </v-chip>
    </div>
  </div>
</template>
<script>
import { utils } from 'frontend-js-shared'
import * as moment from 'moment'

export default {
  name: 'DueDatePicker',

  props: {
    dueDateTime: { required: false, type: String },
    isEditMode: { required: true, type: Boolean },
  },

  data() {
    return {
      dateDialog: false,
      timeDialog: false,
      isDateMissing: false,
      dueDate: '',
      dueTime: '',
    }
  },

  watch: {
    dueDateTime: {
      immediate: true,
      handler(newValue) {
        this.dueDate = this.getDueDate(newValue)
        this.dueTime = this.getDueTime(newValue)
      },
    },
  },

  computed: {
    formattedDate() {
      if (!this.dueDate || !this.dueTime) return null

      const dateToFormat = new Date(this.getISODueDate())

      return utils.dates.formatDate(dateToFormat, 'dddd, MMMM Do YYYY')
    },
  },

  methods: {
    getISODueDate() {
      return moment(
        this.dueDate + this.dueTime,
        'YYYY-MM-DDTHH:mm'
      ).toISOString()
    },

    onDueDateChange() {
      if (!this.dueTime) this.dueTime = '23:00'
      this.$emit('change', this.getISODueDate())
    },

    onDueTimeChange() {
      if (this.dueTime && !this.dueDate) return (this.isDateMissing = true)

      this.dueDate = this.getISODueDate()

      this.$emit('change', this.dueDate)
    },

    clearDueDate() {
      this.$emit('change', null)

      this.dueDate = null
      this.dueTime = null
    },

    getDueDate(dueDate) {
      const date = dueDate || null
      if (!date) return date
      return moment(date).format('YYYY-MM-DD')
    },

    getDueTime(dueDate) {
      const date = dueDate || null
      if (!date) return date
      return moment(date).format('HH:mm')
    },
  },
}
</script>
